import { BulkOperators } from '@/lib/enums';

function applyPropertyChanges(currentProps = [], propChanges) {
  const { create = [], update = [], remove = [] } = propChanges;

  const mutation = {
    create: [],
    update: [],
    remove: [],
  };

  const currentMap = new Map(currentProps.map((p) => [p.key, p.value]));
  let hasChanges = false;

  create.forEach((prop) => {
    const key = prop.property_uuid || prop.key;
    const value = prop.value || prop.option_uuid || '';
    if (key && !currentMap.has(key)) {
      mutation.create.push({ key, value });
      hasChanges = true;
    }
  });

  update.forEach((prop) => {
    const key = prop.property_uuid || prop.key;
    const value = prop.value || prop.option_uuid || '';
    if (key && currentMap.has(key) && currentMap.get(key) !== value) {
      mutation.update.push({ key, value });
      hasChanges = true;
    }
  });

  remove.forEach((key) => {
    if (currentMap.has(key)) {
      mutation.remove.push(key);
      hasChanges = true;
    }
  });

  if (!hasChanges) {
    return null;
  }

  Object.keys(mutation).forEach((action) => {
    if (mutation[action].length === 0) {
      delete mutation[action];
    }
  });

  return mutation;
}

/**
 * @param {Object} snapshot
 * @param {Object} bulk
 * @param {String[]} bulk.uuids
 * @param {String} [bulk.property]
 * @param {Number} [bulk.value]
 * @param {String} [bulk.operator]
 * @param {Object} [bulk.properties]
 * @returns {Object}
 */
export default function bulk(snapshot, bulk) {
  if (!snapshot) {
    return null;
  }

  const now = Date.now();
  const mutation = {
    created_at: now,
    entities: {
      roles: {
        update: [],
      },
    },
  };

  const { uuids, property, value, operator, properties } = bulk;

  const convertValue = (operator, originalValue, newValue) => {
    switch (operator) {
      case BulkOperators.INCREASE:
        return originalValue + newValue;
      case BulkOperators.INCREASE_PERCENTAGE:
        return originalValue + originalValue * (newValue / 100);
      case BulkOperators.DECREASE:
        return originalValue - newValue;
      case BulkOperators.DECREASE_PERCENTAGE:
        return originalValue - originalValue * (newValue / 100);
      case BulkOperators.SET:
      default:
        return newValue;
    }
  };

  uuids.forEach((uuid) => {
    const entity = snapshot.entities.roles[uuid];
    if (!entity) {
      return;
    }

    const roleUpdate = {
      uuid,
      updated_at: now,
    };

    if (property && value !== undefined) {
      const originalValue = entity[property];
      let newValue = convertValue(operator, parseFloat(originalValue), value);

      if (property === 'budget') {
        newValue = Math.max(0, Math.min(newValue, 999999999));
      }

      if (property === 'fte') {
        newValue = Math.max(0, Math.min(newValue, 100));
        if (entity.person_uuid && newValue !== originalValue) {
          mutation.entities.roles.calculate ??= [];
          mutation.entities.roles.calculate.push(uuid);
        }
      }

      roleUpdate[property] = newValue;
    }

    if (properties && typeof properties === 'object') {
      const propertiesInput = applyPropertyChanges(
        entity.properties,
        properties
      );
      if (propertiesInput) {
        roleUpdate.properties = propertiesInput;
      }
    }

    mutation.entities.roles.update.push(roleUpdate);
  });

  return mutation;
}
